import { render, staticRenderFns } from "./PauseMockModal.vue?vue&type=template&id=04b450ec&scoped=true"
import script from "./PauseMockModal.vue?vue&type=script&lang=js"
export * from "./PauseMockModal.vue?vue&type=script&lang=js"
import style0 from "./PauseMockModal.vue?vue&type=style&index=0&id=04b450ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b450ec",
  null
  
)

export default component.exports